<div class="fixed w-full">

    <!-- Content area -->
    <div>

      <!-- Report Header -->
      <app-report-header
        (dataEmitter)="receiveSidebarTabs($event)"
        (dataEmitter2)="receiveAside($event)"
        (asideStateChange)="handleAsideStateChange($event)">
      </app-report-header>

      <!-- Tags -->
      <!--
      <app-report-tags [isVisible]="showTagsModal" [reportId]="report.id" (modalClosed)="handleTagsModalClose()"></app-report-tags>
      -->

      <!-- Share -->
      <app-share [isVisible]="showShareModal" (modalClosed)="handleShareModalClose()"></app-share>

      <!-- ICP Score -->
      <app-icp-score [isVisible]="showIcpScoreModal" [reportSearch]="report" [company]="company" (modalClosed)="handleIcpScoreModalClose()"></app-icp-score>

      <!-- Edit Prompt -->
      <app-edit-prompt
        [isVisible]="showEditPromptModal"
        [assistantPrompt]="assistantPrompt"
        [promptValue]="promptValue"
        (modalClosed)="handleEditPromptModalClose()">
      </app-edit-prompt>

      <!-- Collecting Data -->
      <app-report-loader *ngIf="report" [searchId]="report.id" [isVisible]="showReportLoaderModal" (modalClosed)="handleReportLoaderModalClose()"></app-report-loader>

      <!-- Change Company Modal -->
      <app-change-company-modal [reportSearch]="report" (close)="closeModal()"></app-change-company-modal>

      <!-- Company Details Modal -->
      <app-company-details-modal
        [isVisible]="showCompanyDetailsModal"
        [company]="selectedCompanyForModal"
        (modalClosed)="handleCompanyDetailsModalClose()">
      </app-company-details-modal>

      <!-- Edit Contact Modal -->
      <app-edit-contact-modal
        [isVisible]="showEditContactModal"
        [emails]="contactEmailsForModal"
        [phoneNumbers]="contactPhonesForModal"
        [searchId]="report?.id"
        [contactType]="contactTypeForModal"
        (modalClosed)="handleEditContactModalClose()"
        (contactUpdated)="handleContactUpdated($event)">
      </app-edit-contact-modal>

      <!-- Regenerate confirmation modal (same overlay as the Share modal) -->
      <div *ngIf="showRegenerateModal" class="relative z-[100]" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity" (click)="cancelRegenerate()"></div>

        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div class="relative transform overflow-hidden rounded-2xl bg-white p-6 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm dark:bg-indigo-custom">
              <h3 class="text-base font-semibold text-secondary-900 dark:text-primary-100">
                {{ 'report.regenerate.modal_title' | translate }}
              </h3>
              <p class="mt-2 text-sm text-secondary dark:text-primary-200">
                {{ 'report.regenerate.modal_body' | translate }}
              </p>
              <div class="mt-5 flex justify-end gap-2">
                <button type="button" (click)="cancelRegenerate()"
                        class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-secondary-900 hover:bg-gray-50 dark:border-gray-600 dark:text-primary-200">
                  {{ 'report.regenerate.cancel' | translate }}
                </button>
                <button type="button" (click)="confirmRegenerate()"
                        class="rounded-lg bg-violet-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-violet-600">
                  {{ 'report.regenerate.confirm' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sales Qualify guided process (modal) — at report root so it covers the profile header -->
      <app-sql-qualify-wizard *ngIf="company" [report]="report" [company]="company"></app-sql-qualify-wizard>

      <!-- Edit Revenue Modal -->
      <app-edit-revenue
        [isVisible]="showEditRevenueModal"
        [shortDescription]="revenueShortForModal"
        [longDescription]="revenueLongForModal"
        [searchId]="report?.id"
        [searchCompanyId]="company?.id"
        [reportId]="reportId"
        (modalClosed)="handleEditRevenueModalClose()">
      </app-edit-revenue>

      <!-- Main content -->
      <div>

        <!-- TW Elements is free under AGPL, with commercial license required for specific uses. See more details: https://tw-elements.com/license/ and contact us for queries at tailwind@mdbootstrap.com -->

          <!--
              Height of header: 4 rem (64px)
              Width of aside: 24rem
              Width of sidebar: 5rem

              mr-[calc(24rem+5rem)] = Margin right: Aside + Sidebar
              md:w-[calc(100%-5rem)] = Full width - Sidebar
              lg:w-[calc(100%-(24rem+5rem))] = Full width - (Aside + Sidebar)
          -->

        <!--
        <main [ngClass]="(aside ? 'hidden' : 'flex') + (!isHeaderVisible ? ' !rounded-t-none !inset-shadow-sm' : '')"
               class="main lg:flex fixed mt-[64px] inset-y-0"
               [class.mr-[calc(24rem+5rem)]="aside"
               [class.pr-24]="!aside">
               -->
        <main class="main">

            <!-- Primary column -->
            <!--
            <section aria-labelledby="primary-heading" class="flex flex-col h-screen min-w-0 lg:order-last w-full overflow-hidden">
            -->
          <section aria-labelledby="primary-heading"
                   class="flex flex-col h-screen min-w-0 lg:order-last w-full overflow-hidden transition-all duration-400"
                   [ngClass]="{
                     'md:w-[calc(100%-5rem)]': true,
                     'lg:w-[calc(100%-(24rem+5rem))]': aside,
                     'lg:w-[calc(100%-5rem)]': !aside
                   }">

              <h1 id="primary-heading" class="sr-only">Content</h1>

              <!-- Content -->
              <div class="h-full relative">

                <!-- Profile Header -->
                <!--
                <div [@slideInOut]="isHeaderVisible ? 'visible' : 'hidden'" class="fixed w-full md:pr-[5rem] lg:pr-0 lg:w-[calc(100%-(24rem+5rem))] z-10">
                -->
                <div #profileHeaderContainer
                     [@slideHeader]="isHeaderVisible ? 'visible' : 'hidden'"
                     [ngClass]="{
                       'w-full': isMobile,
                       'lg:w-[calc(100%-(24rem+5rem))]': !isMobile && aside,
                       'lg:w-[calc(100%-5rem)]': !isMobile && !aside
                     }"
                     [@widthAnimation]="{
                       value: aside ? 'aside' : 'noAside',
                       params: {
                         width: isMobile ? 'calc(100%)' : (aside ? 'calc(100% - (24rem + 5rem))' : 'calc(100% - 5rem)')
                       }
                     }"
                     class="fixed z-20">

                  <app-profile-header [reportSearch]="report"
                                      [company]="company"
                                      (icpScoreClicked)="openIcpScoreModal()"
                                      (dataEmitter)="receiveExpandedPersonAndCompany($event)"
                                      (shareClicked)="openShareModal()"
                                      (reportLoaderClicked)="openReportLoaderModal()"
                                      (editPromptToggled)="onEditPromptToggled($event)"
                                      (companyDetailsModalRequested)="openCompanyDetailsModal($event)"
                                      (editRevenueModalRequested)="openEditRevenueModal($event)"
                                      (regenerateClicked)="openRegenerateModal()"
                                      (tagsHeightChange)="updateTagsHeight($event)">
                  </app-profile-header>
                </div>

                <!--
                    Width of aside: 24rem
                    Width of sidebar: 5rem
                    <div class="fixed w-full h-screen md:w-[calc(100%-(5rem))] lg:w-[calc(100%-(24rem+5rem))] pb-10" [ngClass]="(personExpanded && companyExpanded) ? 'pt-[18.6rem] lg:pt-[18.6rem] xl:pt-[20rem]' : 'pt-[18.6rem] lg:pt-[18.6rem] xl:pt-[9.45rem]'">
                -->
                <!-- class="fixed w-full h-screen md:w-[calc(100%-(5rem))] lg:w-[calc(100%-(24rem+5rem))] pb-10" [ngClass]="(personExpanded && companyExpanded) ? 'pt-[35.3rem] lg:pt-[18.6rem] xl:pt-[20rem]' : 'pt-[15.5rem] lg:pt-[18.6rem] xl:pt-[9.45rem]'" -->


                <!--
                <div class="fixed w-full h-screen md:w-[calc(100%-(5rem))] lg:w-[calc(100%-(24rem+5rem))]" [ngStyle]="{'padding-top': paddingTop}">
                -->
                <div class="fixed h-screen transition-all duration-400"
                     [@widthAnimation]="{
                       value: aside ? 'aside' : 'noAside',
                       params: {
                         width: isMobile ? 'calc(100%)' : (aside ? 'calc(100% - (24rem + 5rem))' : 'calc(100% - 5rem)')
                       }
                     }"
                     [ngStyle]="{'padding-top': paddingTop}">

                  <div #scrollableDiv2
                       class="scrollable-div h-full overflow-y-auto overscroll-contain transition-all duration-400 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-violet-200 hover:scrollbar-thumb-transparent"
                       [ngStyle]="{
                         'height': 'calc(100vh - ' + paddingTop + ')',
                         'padding-bottom': isMobile ? 'calc(env(safe-area-inset-bottom, 0rem) + 8rem)' : '2.5rem'
                       }">

                    <!-- Person insights -->
                    <div id="personInsights" class="min-h-fit">
                      <app-person-insights [edit]="edit"
                                           [reportSearch]="report"
                                           [company]="company"
                                           (editPromptToggled)="onEditPromptToggled($event)"
                                           (editContactModalRequested)="openEditContactModal($event)">
                      </app-person-insights>
                    </div>

                    <!-- Company Insights -->
                    <div id="companyInsights" class="min-h-fit">
                      <app-company-insights [reportSearch]="report"
                                            [company]="company"
                                            [edit]="edit"
                                            [aside]="aside"
                                            (editContactModalRequested)="openEditContactModal($event)">
                      </app-company-insights>
                    </div>

                    <!-- AI Agent Tool Box -->
                    <!--
                    <div id="aiAgentToolBox" class="min-h-fit">
                      <app-ai-agent-tool-box [reportSearch]="report"
                                             [company]="company">
                      </app-ai-agent-tool-box>
                    </div>
                    -->

                    <!-- People Recommendations -->
                    <div id="peopleRecommendations" class="min-h-fit">
                      <app-people-recommendations
                        [reportSearch]="report"
                        [company]="company">
                      </app-people-recommendations>
                    </div>

                    <!-- Industry Insights -->
                    <!--
                    <div id="industryInsights" class="min-h-fit">
                      <app-industry-insights [reportSearch]="report"
                                             [company]="company"
                                             [edit]="edit">
                      </app-industry-insights>
                    </div>
                    -->

                  </div>

                </div>

              </div>
              <!-- / Content -->

            </section>

        </main>

          <!-- Secondary column (hidden on smaller screens) -->
          <!--
              Height of header: 4 rem (64px)

              md:w-[calc(100%-5rem)] = Full width - Sidebar
              h-[calc(100%-4rem)] = Full height - Header height

              md:inset-y-0 mt-0 md:mt-[4rem] - removed on 12.12.2023
          -->
        <!--
        <aside [ngClass]="aside ? 'flex w-fit' : 'hidden'" class="aside py-3 pr-3 lg:flex fixed right-0 mr-0 md:mr-20 w-full md:w-[calc(100%-5rem)] lg:w-96 h-[calc(100%-4rem)] overflow-y-auto">
        -->
        <aside
          class="aside md:py-3 md:pr-3 fixed right-0 mr-0 md:mr-20 w-full md:w-[calc(100%-5rem)] lg:w-96 h-[calc(100%-4rem)] transition-transform duration-400"
          [style.display]="(aside$ | async) ? 'flex' : 'none'"
          [@slideAside]="(aside$ | async) ? 'open' : 'closed'"
        >

          <div [@slideAside]="(aside$ | async) ? 'open' : 'closed'"
               class="rounded-xl w-full overflow-hidden transition-all duration-400"
               (@slideAside.done)="onAnimationDone($event)">

            <!--
            <div [class.bg-violet-100]="aside$ | async" [class.dark:bg-[#252c5f]]="aside$ | async" class="rounded-xl p-3 mb-3">
              <h3 class="text-lg text-secondary dark:text-white font-semibold">Workspace</h3>
            </div>
            -->

            <div class="rounded-xl h-full">

              <!-- Tags -->
              <app-tags *ngIf="sidebarTabs[0].current"
                        [aside$]="aside$"
                        (dataEmitter)="receiveAside($event)"
                        (handleAsideEmitter)="receiveAside($event)"
                        [report]="report$ | async"
                        (selectedFiltersChange)="updateSelectedFilters($event)"
                        class="w-full"></app-tags>

              <!-- Assistant -->
              <app-assistant *ngIf="sidebarTabs[1].current"
                             [aside$]="aside$"
                             (dataEmitter)="receiveAside($event)"
                             [report]="report"
                             [icebreakers]="icebreakers"
                             [meetingAgendaSteps]="meetingAgendaSteps"
                             class="w-full">
              </app-assistant>

              <!-- Edit -->
              <app-edit *ngIf="sidebarTabs[2].current" [aside$]="aside$" (dataEmitter)="receiveAside($event)" class="w-full"></app-edit>

              <!-- Notes -->
              <app-notes *ngIf="sidebarTabs[3].current" [aside$]="aside$" (dataEmitter)="receiveAside($event)" [report]="report" class="w-full"></app-notes>

              <!-- CRM -->
              <app-crm *ngIf="sidebarTabs[5].current" [aside$]="aside$" (dataEmitter)="receiveAside($event)" [report]="report" class="w-full h-full flex flex-col"></app-crm>
            </div>

          </div>
        </aside>

        <!-- Sidebar -->
        <app-report-sidebar
          (dataEmitter)="receiveSidebarTabs($event)"
          (dataEmitter2)="receiveAside($event)"
          (asideStateChange)="handleAsideStateChange($event)">
        </app-report-sidebar>

      </div>

      <app-subscription-banner></app-subscription-banner>

    </div>

    <div *ngIf="loading" class="absolute bg-[#161e52] rounded-t-md flex flex-col items-center justify-center min-h-screen w-full">
      <span class="loader"></span>
      <h1 class="ml-4 mt-3  text-3xl font-semibold leading-none tracking-tight  text-primary-100 md:text-3xl lg:text-3xl ">Loading your report</h1>
      <p class="text-mg mt-3 m-4 text-center text-primary-100">Come back to this page later or wait for the report to finish. <br />
        The page will <span class=" font-extrabold text-white">automatically</span> display the information once the research has been finished.</p>
    </div>

  <div class="hidden bg-indigo-500"></div>

</div>
